import axios from 'axios';
import axiosRetry from 'axios-retry';
import { getDataProps, Dataset } from '../utils/dataProps';

const props: Dataset = getDataProps();
const endpoint = props?.endpoint || "";

const axiosConfig = {
    baseURL: `${endpoint}/`,
    credentials: 'include',
    timeout: 4000,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    },
};

const retryDelay = () => 1000;

const axiosInstance = axios.create({ ...axiosConfig });

axiosRetry(axiosInstance, { retries: 2, retryDelay });

export default axiosInstance;
